import axios from 'axios';

import { CATALYST_API_FUNCTION_ID } from '../../utils/constants.js';

import { authState } from '../state/auth-state.jsx';

export const msCatalystApi = axios.create({
  withCredentials: true,
  baseURL: `/server/${CATALYST_API_FUNCTION_ID}`,
  headers: {
    'Access-Control-Allow-Origin': '',
  },
});

msCatalystApi.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    // Network-level failures (aborted request, offline, CORS) reject with no
    // `response`, so this must not assume one is present.
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.message === 'UNAUTHORIZED'
    ) {
      authState.token = null;
      authState.isAuth = false;
      authState.user = null;
      authState.userIsInMatchroom = false;
    }

    return Promise.reject(error);
  },
);

/*
export const msCatalystApiNext = ofetch.create({
  withCredentials: true,
  baseURL: `/server/${CATALYST_API_FUNCTION_ID}`,
  headers: {
    'Access-Control-Allow-Origin': '',
  },
  onResponseError({ request, response, options }) {
    if (response.status === 401 && response.body.message === 'UNAUTHORIZED') {
      authState.token = null;
      authState.isAuth = false;
      authState.user = null;
      authState.userIsInMatchroom = false;
    }

    return Promise.reject(response);
  },
});
*/
